// School design presets — mirror of backend app/services/school_design_service.py DESIGN_PRESETS.
// Colors are explicit HEX values; selecting a preset fills all design_* config fields.

export type DesignPresetKey = 'blue' | 'green' | 'dark' | 'warm' | 'sky' | 'emerald'

export interface DesignPresetValues {
  design_primary_color: string
  design_bg_color: string
  design_text_color: string
  design_muted_color: string
  design_button_bg_color: string
  design_button_text_color: string
  design_button_hover_color: string
  design_border_color: string
  design_theme: 'light' | 'dark'
}

export interface DesignPreset {
  key: DesignPresetKey
  label: string
  values: DesignPresetValues
}

export const DESIGN_PRESETS: DesignPreset[] = [
  {
    key: 'blue',
    label: 'Blau (Standard)',
    values: {
      design_primary_color: '#2563eb',
      design_bg_color: '#f9fafb',
      design_text_color: '#111827',
      design_muted_color: '#4b5563',
      design_button_bg_color: '#2563eb',
      design_button_text_color: '#ffffff',
      design_button_hover_color: '#1d4ed8',
      design_border_color: '#d1d5db',
      design_theme: 'light',
    },
  },
  {
    key: 'green',
    label: 'Grün',
    values: {
      design_primary_color: '#16a34a',
      design_bg_color: '#f0fdf4',
      design_text_color: '#111827',
      design_muted_color: '#4b5563',
      design_button_bg_color: '#16a34a',
      design_button_text_color: '#ffffff',
      design_button_hover_color: '#15803d',
      design_border_color: '#86efac',
      design_theme: 'light',
    },
  },
  {
    key: 'dark',
    label: 'Dunkel',
    values: {
      design_primary_color: '#6366f1',
      design_bg_color: '#0f172a',
      design_text_color: '#ffffff',
      design_muted_color: '#cbd5e1',
      design_button_bg_color: '#6366f1',
      design_button_text_color: '#ffffff',
      design_button_hover_color: '#4f46e5',
      design_border_color: '#475569',
      design_theme: 'dark',
    },
  },
  {
    key: 'warm',
    label: 'Warm',
    values: {
      design_primary_color: '#ea580c',
      design_bg_color: '#fffbeb',
      design_text_color: '#111827',
      design_muted_color: '#4b5563',
      design_button_bg_color: '#ea580c',
      design_button_text_color: '#ffffff',
      design_button_hover_color: '#c2410c',
      design_border_color: '#fcd34d',
      design_theme: 'light',
    },
  },
  {
    key: 'sky',
    label: 'Sky',
    values: {
      design_primary_color: '#0284c7',
      design_bg_color: '#f0f9ff',
      design_text_color: '#111827',
      design_muted_color: '#4b5563',
      design_button_bg_color: '#0284c7',
      design_button_text_color: '#ffffff',
      design_button_hover_color: '#0369a1',
      design_border_color: '#7dd3fc',
      design_theme: 'light',
    },
  },
  {
    key: 'emerald',
    label: 'Emerald',
    values: {
      design_primary_color: '#059669',
      design_bg_color: '#ecfdf5',
      design_text_color: '#111827',
      design_muted_color: '#4b5563',
      design_button_bg_color: '#059669',
      design_button_text_color: '#ffffff',
      design_button_hover_color: '#047857',
      design_border_color: '#6ee7b7',
      design_theme: 'light',
    },
  },
]

export function getPreset(key: string): DesignPreset | undefined {
  return DESIGN_PRESETS.find(p => p.key === key)
}
